// Import styles
import { StyledImage } from './styles';

// Import icons
import placeholderImg from 'assets/images/slider_item_placeholder_landscape.png';

type Props = { url: string | undefined; alt: string; isSmall: boolean };

const PacketImage = ({ url, alt, isSmall }: Props) => {
	const imgUrl = url ?? placeholderImg;

	return <StyledImage src={imgUrl} alt={alt} isSmall={isSmall} />;
};

export default PacketImage;
